import * as types from './types';

export const toggleFilterIndex = index => ({
  type: types.TOGGLE_FILTER_INDEX,
  index,
});

export const removeFilterByIndex = (index, dashboardId) => ({
  type: types.REMOVE_FILTER_BY_INDEX,
  index,
  dashboardId,
});

export const clearFilterIndices = () => ({
  type: types.CLEAR_FILTER_INDICES,
});

export const addMetric = metric => ({
  type: types.ADD_METRIC,
  metric,
});

export const removeMetric = metric => ({
  type: types.REMOVE_METRIC,
  metric,
});

export const addSavedFilters = (filters, dashboardId, replaceAll) => ({
  type: types.ADD_SAVED_FILTERS,
  filters,
  dashboardId,
  replaceAll,
});

export const emptySavedFilter = () => ({
  type: types.EMPTY_SAVED_FILTER,
});

export const toggleNewComparisonDashboard = flag => ({
  type: types.TOGGLE_NEW_COMPARISON_DASHBOARD,
  flag,
});

export const modifyComparison = (mode, activeEditId, config, filterColor, resetDiagnostics) => ({
  type: types.MODIFY_COMPARISON,
  mode,
  activeEditId,
  config,
  filterColor,
  resetDiagnostics,
});

export const fetchCompareData = (id, config, isZoom = false) => ({
  type: types.FETCH_COMPARE_DATA,
  id,
  config,
  isZoom,
});

export const applySavedFilters = filters => ({
  type: types.APPLY_SAVED_FILTERS,
  filters,
});

export const applySavedMetricList = list => ({
  type: types.APPLY_SAVED_METRICLIST,
  list,
});

export const applySavedIndex = index => ({
  type: types.APPLY_SAVED_INDEX,
  index,
});

export const clearCompareZoomData = () => ({
  type: types.CLEAR_COMPARE_ZOOM_DATA,
});

export const clearModifyComparison = () => ({
  type: types.CLEAR_MODIFY_COMPARISON,
});

export const updateZoomInterval = (zoomInterval, dashboardId) => ({
  type: types.UPDATE_ZOOM_INTERVAL,
  zoomInterval,
  dashboardId,
});

export const exportCompareMetric = (exportedMetric = '') => ({
  type: types.EXPORT_COMPARE_METRIC,
  exportedMetric,
});
